import React from 'react';
import classNames from 'classnames';

import './unread-badge.scss';

const UnreadBadge = ({ isCollab, isBrandsNavbar, isCreatorsNavbar, isMyProposals, isVerticalMenu, isInbox, isExpanded, noEffect }) => (
  <span
    className={classNames('badge', 'badge__navbar', {
      '-is-collab': isCollab,
      '-is-brands-navbar': isBrandsNavbar,
      '-is-creators-navbar': isCreatorsNavbar,
      '-is-my-proposals': isMyProposals,
      '-is-vertical-menu': isVerticalMenu,
      '-is-inbox': isInbox,
      '-is-expanded': isExpanded,
      '-no-effect': noEffect
    })}
  />
);

export default React.memo(UnreadBadge);
